module.exports = __webpack_public_path__ + "pic_bizny_web_01-640@2x.png?d98c307c61ed929fb87aa39f89150025";